import { render, staticRenderFns } from "./products-cats.vue?vue&type=template&id=0e74902e"
import script from "./products-cats.vue?vue&type=script&lang=js"
export * from "./products-cats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports